import type { InputHub } from './InputHub';

const STEER_KEYS_LEFT = ['ArrowLeft', 'KeyA'];
const STEER_KEYS_RIGHT = ['ArrowRight', 'KeyD'];
const THROTTLE_KEYS = ['ArrowUp', 'KeyW'];
const BRAKE_KEYS = ['ArrowDown', 'KeyS'];

/**
 * Tastatur zum Entwickeln und Testen am Rechner. Auf dem Handy irrelevant,
 * kostet aber nichts.
 */
export class KeyboardInput {
  private readonly down = new Set<string>();
  private readonly onKeyDown: (e: KeyboardEvent) => void;
  private readonly onKeyUp: (e: KeyboardEvent) => void;
  private readonly onBlur: () => void;

  constructor(private readonly hub: InputHub) {
    this.onKeyDown = (e) => {
      if (e.repeat) return;
      this.down.add(e.code);
      switch (e.code) {
        case 'KeyR':
          hub.requestReset();
          break;
        case 'KeyC':
          hub.requestCameraChange();
          break;
        case 'KeyH':
          hub.hornActive = true;
          break;
        default:
          break;
      }
      if (isGameKey(e.code)) e.preventDefault();
      this.apply();
    };

    this.onKeyUp = (e) => {
      this.down.delete(e.code);
      if (e.code === 'KeyH') hub.hornActive = false;
      this.apply();
    };

    this.onBlur = () => this.clear();

    window.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('keyup', this.onKeyUp);
    window.addEventListener('blur', this.onBlur);
  }

  private apply(): void {
    const k = this.hub.keyboard;
    const left = STEER_KEYS_LEFT.some((c) => this.down.has(c));
    const right = STEER_KEYS_RIGHT.some((c) => this.down.has(c));
    k.steer = (right ? 1 : 0) - (left ? 1 : 0);
    k.throttle = THROTTLE_KEYS.some((c) => this.down.has(c)) ? 1 : 0;
    k.brake = BRAKE_KEYS.some((c) => this.down.has(c)) ? 1 : 0;
    k.handbrake = this.down.has('Space');
  }

  clear(): void {
    this.down.clear();
    this.hub.hornActive = false;
    this.apply();
  }

  dispose(): void {
    window.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('keyup', this.onKeyUp);
    window.removeEventListener('blur', this.onBlur);
  }
}

function isGameKey(code: string): boolean {
  return (
    STEER_KEYS_LEFT.includes(code) ||
    STEER_KEYS_RIGHT.includes(code) ||
    THROTTLE_KEYS.includes(code) ||
    BRAKE_KEYS.includes(code) ||
    code === 'Space'
  );
}
